import {
  SET_APPLICATION_STEP,
} from './mutation-types';

export default {
  /**
  * Set media for a product
  * @param {object} state - the vuex state object
  * @param {string} applicationStep - Global application state linked to onboarding steps
  */
  [SET_APPLICATION_STEP](state, applicationStep) {
    state.applicationStep = applicationStep;
  },
};
